// Function to reset all States in Redux
export const resetApp = () => ({
  type: 'RESET_APP',
})
